import React from "react";
import AmlTable from "../AmlTable";
import { Box } from "@mui/material";

const AmlValid = ({ allAml, handleOpenLegendaModal }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <AmlTable
        data={allAml}
        onStatusInfoClick={handleOpenLegendaModal}
        emptyMessage="Non ci sono aml validi"
        columns={["id", "stato", "cliente", "email", "approved_at"]}
      />
    </Box>
  );
};

export default AmlValid;
